// extracted by mini-css-extract-plugin
export default {"cuadroAlumnos":"AlumnoPage_cuadroAlumnos__SzvUz"};